import { render } from "./SendMoney.vue?vue&type=template&id=52c0ae65"
import script from "./SendMoney.vue?vue&type=script&lang=js"
export * from "./SendMoney.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__